<template>
  <div class="" style="height: 8vh">
    <!-- {{userProfile}} -->
    <div class="text-h5 text-bold text-center q-my-lg">
      {{ userProfile.nickname }}，你好！ 感谢参与
      <span class="text-primary"> 浙江省小微企业调查 2021 </span>
    </div>
<!-- 进度条 -->
    <!-- <div class="items-center row justify-center text-bold">
    完成进度：
    <line-progress
      v-if="progress"
      :progress="progress"
      :delay="0.1"
      style="width: 40vw; "
    />
    </div> -->
  </div>
</template>

<script>
export default {
  components: {
    LineProgress: () =>
      import("../../components/progress-bar/LineProgress.vue"),
  },
  props: {
    userProfile: {},
    telpSampleList: {},
  },
  // data() {
  //   return {
  //     progress: 0,
  //   };
  // },

  // watch: {
  //   telpSampleList: {
  //     immediate: true,
  //     handler() {
  //       const doneNum = this.telpSampleList.filter((sample) => {
  //         return sample.telp_intv && sample.telp_intv.status;
  //       }).length;
  //       this.progress = (doneNum / this.telpSampleList.length) * 100;
  //       // console.log(this.progress)
  //     },
  //   },
  // },

  computed: {
    progress(){
      return (this.telpSampleList.filter((sample) => {
          return sample.telp_intv && sample.telp_intv.status;
        }).length / this.telpSampleList.length) * 100
    }
  },
};
</script>

<style>
</style>